export const NestedStackNavigator = () => {};
